<template>
    <div>
        <div class="mt-[20px] md:mt-[30px] mb-[10px] font-medium">
            {{ title }}
        </div>
        <div class="w-full mt-2 py-2 px-4 bg-gray-200 text-black border border-gray-600 rounded-full">
            {{ modelValue }}
        </div>
    </div>
</template>

<script>
/**純文字欄位 */
export default{
    name: 'PlainTextField',
    components: {},
    props: {
        // 編輯style開關
        editStyle: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '',
        },
        modelValue:{
            type: [String, Number],
            default: '', 
        },
        clarityClass:{
            type: String,
            default: '',
        },
    },
};
</script>